/* eslint-disable*/
import React, { useContext, useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import '../StaffAugStatusMaster/staffAugStatusMaster.scss';
import ButtonComponent from '../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import { STAFF_AUGMENTATION, OOPS_TRY_AGAIN } from '../../Constants/strings';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import BackIcon from '../../Assets/images/svg/dar_back_arrow.svg';
import DeleteIcon from '../../Assets/images/svg/dar_delete.svg';
import DisabledDeleteIcon from '../../Assets/images/svg/dar_delete_gray.svg';
import { AuthContext } from '../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../Constants/modules';
import SearchDropdown from '../../Components/Dropdown/dropdown';
import UseAxios from '../../Api/http/http';
import { getStaffingStatus } from '../../Api/request/staffAugStatusMaster';
import { customStatusStyles } from './staffAugmentationUtils';
import { useSnackbar } from '../../Components/Snackbar/snackBarProvider';
import MapEmployee from './mapEmployee/mapEmployee';
import {
  getRequestResourceData,
  updateRequestResourceData,
  deleteStaffRequirement,
  generateResume,
  getViewFileData,
} from '../../Api/request/resourceRequest';
import { getEmployeeNames } from '../../Api/request/staffAugmentation';
import MultiSelectSearchDropdown from '../../Components/MultiFilterSearch/multiFilterSearch';
import { useLocation, useNavigate } from 'react-router-dom';
import EnableDisableCategoryDialog from '../CertificationCategory/enableDisableCategoryDialog';
import DeleteResourceRequirementDialog from './deleteResourceRequirementDialog';
import SkillIcon from '../../Assets/images/svg/staff_request_resource_page_icons1.svg';
import PositionIcon from '../../Assets/images/svg/staff_request_resource_page_icons2.svg';
import FulfilledPositionIcon from '../../Assets/images/svg/staff_request_resource_page_icons3.svg';
import OnboardPositionIcon from '../../Assets/images/svg/staff_request_resource_page_icons4.svg';
import InterviewRequiredIcon from '../../Assets/images/svg/staff_request_resource_page_icons5.svg';
import EmpExperienceIcon from '../../Assets/images/svg/staff_request_resource_page_icons6.svg';
import StaffCard from './staffCard';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDown from '../../Assets/images/svg/drop-down-arrow.svg';
import excelIcon from '../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../Assets/images/svg/excel_hover.svg';
import pdfIcon from '../../Assets/images/svg/pdf.svg';
import pdfhoverIcon from '../../Assets/images/svg/pdf_hover.svg';
import {
  getResourceRequirementReportsExcel,
  getResourceRequirementReportsPdf,
} from '../../Api/request/reports';
import menuIcon from '../../Assets/images/svg/dar_kebab.svg';
import ViewResumeDialog from './Resume/viewResume';
import ViewSuggestionDialog from './ViewSuggestion/viewSuggestion';
import { decryptHtml } from '../../Utils/decrypt-html';
import UploadResumeDialog from './Resume/uploadResumePopUp';
import { getResourceViewSuggestion } from '../../Api/request/resourceRequest';
import { fetchProfilePic } from '../SkillMap/apiCallUtil';
import ResumeWatermarkDialog from './Resume/resumeWatermarkPopUp';

const StaffAugRequestRequirement = () => {
  const { userProfile } = useContext(AuthContext);
  const { snackbarOpen } = useSnackbar();
  const [isMobileView, setIsMobileView] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [mapEmployeeModel, setMapEmployeeModel] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const [selectEmployee, setSelectEmployee] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [staffResourceRequestId, setStaffResourceRequestId] = useState(null);
  const [isInterview, setIsInterview] = useState();
  const [rows, setRows] = useState([]);
  const [skillsRequired, setSkillsRequired] = useState([]);
  const [resourceOnboarded, setResourceOnboarded] = useState(false);
  const [interviewRequired, setInterviewRequired] = useState(false);
  const [empExperience, setEmpExperience] = useState('');
  const [noOfPositions, setNoOfPositions] = useState(0);
  const [noOfOnboardPositions, setNoOfOnboardPositions] = useState(0);
  const [noOfFulfilledPositions, setNoOfFulfilledPositions] = useState(0);
  const [viewFileLoader, setViewFileLoader] = useState(false);
  const [resumeUpdateProgress, setResumeUpdateProgress] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isExcelHovered, setIsExcelHovered] = useState(false);
  const [isPdfHovered, setIsPdfHovered] = useState(false);
  const [menuAnchorEls, setMenuAnchorEls] = useState({});
  const [selectedMenuRow, setSelectedMenuRow] = useState(null);
  const [viewResumeDialogOpen, setViewResumeDialogOpen] = useState(false);
  const [generateResumeDialogOpen, setGenerateResumeDialogOpen] = useState(false);
  const [selectedResumeRow, setSelectedResumeRow] = useState(null);
  const [resumeViewerOpen, setResumeViewerOpen] = useState(false);
  const [resumeFileUrl, setResumeFileUrl] = useState('');
  const [htmlResumeContent, setHtmlResumeContent] = useState('');
  const popupRefs = useRef({});
  const menuButtonRefs = useRef({});
  const [popupPosition, setPopupPosition] = useState({});
  const [editEmployeeData, setEditEmployeeData] = useState(null);
  const [isSuggestedDialogOpen, setIsSuggestedDialogOpen] = useState(false);
  const [uploadResumeModalOpen, setUploadResumeModalOpen] = useState(false);
  const [selectedUploadRow, setSelectedUploadRow] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [noSuggestions, setNoSuggestions] = useState(false);
  const [employeeNameOptions, setEmployeeNameOptions] = useState([]);
  const [selectedEmployeeName, setSelectedEmployeeName] = useState([]);
  const [resumeWatermarkModalOpen, setResumeWatermarkModalOpen] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(true);

  const content = STAFF_AUGMENTATION.REQUEST_RESOURCING;

  const navigate = useNavigate();

  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.STAFF_AUG_PROJECT_RESOURCING] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };
  const userPermissions = userProfile?.permissions || {};
  const canViewResume = userPermissions[MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_VIEW_RESUME]?.includes('read');
  const canUploadResume = userPermissions[MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_UPLOAD_RESUME]?.includes('update')
    || userPermissions[MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_UPLOAD_RESUME]?.includes('create');
  const canGenerateResume = (row) =>
    (userPermissions[MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_GENERATE_RESUME]?.includes('create')
      || userPermissions[MODULE_NAMES.STAFF_AUG_RESUME_GENERATION_GENERATE_RESUME]?.includes('update')) &&
    row?.employeeId &&
    row?.employeeId !== 'N/A';


  const category = 'client-status';
  // API call to get staff augmentation status options
  const getStatusData = () => {
    UseAxios(getStaffingStatus('', category, true))
      .then((response) => {
        const staffStatus = response.data.staffingStatusDetails.map(
          (statusDetails) => ({
            ...statusDetails,
            name: statusDetails.statusName,
          })
        );
        setStatusOptions(staffStatus);
      })
      .catch(() => setStatusOptions([]));
  };

  const updateReqRequirementStatus = async (payload) => {
    try {
      const response = await UseAxios(updateRequestResourceData(payload));
      if (response.status === 200) {
        return response;
      } else {
        throw new Error(STAFF_AUGMENTATION.UPDATE_ERROR_MESSAGE);
      }
    } catch (error) {
      snackbarOpen(
        content.UPDATE_ERROR_MESSAGE,
        STAFF_AUGMENTATION.ERROR_SEVERITY
      );
      return error;
    }
  };

  const handleReqStatusChange = async (rowId, selectedStatus) => {
    const payload = {
      resourceId: rowId,
      statusId: selectedStatus.id,
      lastUpdatedBy: userProfile.user_name,
    };

    const response = await updateReqRequirementStatus(payload);
    if (response?.status === 200) {
      snackbarOpen(
        content.UPDATE_SUCCESS_MESSAGE,
        STAFF_AUGMENTATION.SUCCESS_SEVERITY
      );
      await getResourceRequirementData();
      const { statusName } = selectedStatus;
      setRows((prevList) =>
        prevList.map((item) =>
          item.id === rowId ? { ...item, status: statusName } : item
        )
      );
    }
  };

  const handleSubmit = async () => {
    const payload = {
      resourceId: selectEmployee.id,
      isInterviewRequired: isInterview,
      lastUpdatedBy: userProfile.user_name,
    };
    const response = await updateReqRequirementStatus(payload);
    if (response?.status === 200) {
      snackbarOpen(
        isInterview
          ? content.ENABLE_DISABLE_DIALOG.DISABLE.MESSAGE
          : content.ENABLE_DISABLE_DIALOG.ENABLE.MESSAGE,
        STAFF_AUGMENTATION.SUCCESS_SEVERITY
      );
      setRows((prevList) =>
        prevList.map((item) =>
          item.id === selectEmployee.id
            ? { ...item, isInteviewRequired: isInterview }
            : item
        )
      );
    }
    setIsDialogOpen(false);
  };

  const getMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
    setIsLaptopView(window.innerWidth >= 1024 && window.innerWidth <= 1200);
  };

  useEffect(() => {
    getMobileView();
    window.addEventListener('resize', getMobileView);
    return () => {
      window.removeEventListener('resize', getMobileView);
    };
  }, []);

  useEffect(() => {
    getEmployeeNameData();
  }, []);

  useEffect(() => {
    if (resumeFileUrl) {
      setResumeViewerOpen(true); // Open the dialog when resumeFileUrl is ready
    }
  }, [resumeFileUrl]);

  const getColumnWidth = (mobile, laptop, defaultWidth) => {
    if (isMobileView) {
      return mobile;
    } else if (isLaptopView) {
      return laptop;
    }
    return defaultWidth;
  };

  const getColumnFlex = (defaultFlex) => {
    if (!isMobileView && !isLaptopView) {
      return defaultFlex;
    }
    return undefined;
  };

  const location = useLocation();
  const { id, clientName } = location?.state?.row || {};

  // API call to get employee names for dropdown
  const getEmployeeNameData = () => {
    UseAxios(getEmployeeNames())
      .then((response) => {
        if (response?.status === 200 && response?.data?.data) {
          const employeeNames = response.data.data.map((emp) => ({
            id: emp.employeeId,
            name: emp.employeeName,
          }));
          setEmployeeNameOptions(employeeNames);
        } else {
          setEmployeeNameOptions([]);
        }
      })
      .catch((error) => {
        console.error('Error in getEmployeeNameData:', error);
        setEmployeeNameOptions([]);
      });
  };

  const getResourceRequirementData = async () => {
    try {
      const filters = {};
      
      // Add employee name filter
      if (selectedEmployeeName && selectedEmployeeName.length > 0) {
        filters.employeeName = selectedEmployeeName.map(emp => emp.name).join(',');
      }
      
      const response = await UseAxios(getRequestResourceData(id, filters));
      const details = response?.data?.resourceRequirementDetails;

      if (Array.isArray(details) && details.length === 0) {
        setSkillsRequired(response?.data?.skillDetails);
        setInterviewRequired(response?.data?.isInterviewRequired);
        setEmpExperience(response?.data?.experience);
        setResourceOnboarded(response?.data?.totalOnboardedPositions);
        setNoOfOnboardPositions(response?.data?.totalOnboardedPositions);
        setNoOfPositions(response?.data?.totalPositions);
        setNoOfFulfilledPositions(response?.data?.totalFulfilledPositions);
        setResourceOnboarded(response?.data?.resourceOnboarded);
        fetchSuggestionsOnLoad();
        setRows([]);
      } else if (response.data) {
        setSkillsRequired(response?.data?.skillDetails);
        setInterviewRequired(response?.data?.isInterviewRequired);
        setEmpExperience(response?.data?.experience);
        setResourceOnboarded(response?.data?.totalOnboardedPositions);
        setNoOfOnboardPositions(response?.data?.totalOnboardedPositions);
        setNoOfPositions(response?.data?.totalPositions);
        setNoOfFulfilledPositions(response?.data?.totalFulfilledPositions);
        setResourceOnboarded(response?.data?.resourceOnboarded);
        let mappedRows = (response?.data?.resourceRequirementDetails || []).map(item => ({
          ...item,
        }));
        setRows(mappedRows);
      } else {
        setRows([]);
      }
    } catch (error) {
      setRows([]);
      console.error('Error fetching resource data:', error);
      snackbarOpen('Error fetching resource data', 'error');
    }
  };

  const getResourceViewSuggestionData = async () => {
    try {
      const response = await UseAxios(getResourceViewSuggestion(id));

      if (response.data?.employeeData && response.data.employeeData.length > 0) {
        setSuggestions(response.data.employeeData);
        setNoSuggestions(false);
        fetchPhotoData(response.data.employeeData);
        return true;
      }
      else {
        setSuggestions([]);
        setNoSuggestions(true);
        return false;
      }
    } catch (error) {
      setSuggestions([]);
      console.error('Error fetching resource view suggestions:', error);
      snackbarOpen(OOPS_TRY_AGAIN, 'warning');
    }
  };

  const fetchPhotoData = async (employeeData) => {
    const userIds = employeeData.map((item) => item.employeeNo);
    const profilePics = await fetchProfilePic(userIds);

    // Create a lookup object for profilePics
    const profilePicLookup = profilePics.reduce((acc, pic) => {
      acc[pic.employeeId] = pic.photoSignedUrl;
      return acc;
    }, {});
    // Map the suggestions array and add the photoSignedUrl
    const updatedSuggestedValues = employeeData.map((item) => {
      return {
        ...item,
        photoSignedUrl: profilePicLookup[item.employeeNo] || null,
      };
    });
    setSuggestions(updatedSuggestedValues);
  };

  const fetchSuggestionsOnLoad = async () => {
    const hasSuggestions = await getResourceViewSuggestionData();
    if (hasSuggestions) {
      setIsSuggestedDialogOpen(true);
    }
  };

  useEffect(() => {
    getResourceRequirementData();
    getStatusData();
  }, []);

  useEffect(() => {
    // Trigger filtering when employee name changes
    getResourceRequirementData();
  }, [selectedEmployeeName]);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setIsDeleteDialogOpen(false);
  };
  const handleDeleteClick = (data) => {
    setIsDeleteDialogOpen(true);
    setStaffResourceRequestId(data.id);
  };
  const desktopColumns = [
    {
      field: content.FIELDS.DATE,
      headerName: content.HEADERS.DATE,
      sortable: false,
      disableColumnMenu: true,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
      renderCell: (params) => {
        const date = new Date(params.value);
        const day = date.getDate();
        const month = date.toLocaleString('en-GB', { month: 'short' });
        const year = date.getFullYear();
        return (
          <div className="staff-aug-table-cell">
            {`${day} ${month}, ${year}`}
          </div>
        );
      },
    },
    {
      field: content.FIELDS.EMPLOYEE_NAME,
      headerName: content.HEADERS.NAME,
      sortable: false,
      disableColumnMenu: true,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
      renderCell: (params) => {
        const valueToShow =
          params.row[content.FIELDS.OTHERS] ??
          params.row[content.FIELDS.EMPLOYEE_NAME];
        return <div className="staff-aug-table-cell">{valueToShow}</div>;
      },
    },
    {
      field: content.FIELDS.EMPLOYEE_ID,
      headerName: content.HEADERS.EMPLOYEE_ID,
      sortable: false,
      disableColumnMenu: true,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
      renderCell: (params) => (
        <div className="staff-aug-table-cell">{params.value}</div>
      ),
    },
    {
      field: content.FIELDS.EMAIL_ID,
      headerName: content.HEADERS.EMAIL_ID,
      sortable: false,
      disableColumnMenu: true,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
      renderCell: (params) => (
        <div className="staff-aug-table-cell">{params.value}</div>
      ),
    },
    {
      field: content.FIELDS.SKILLS,
      headerName: content.HEADERS.SKILLS,
      sortable: false,
      disableColumnMenu: true,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
      renderCell: (params) => (
        <div className="staff-aug-table-cell">{params.value}</div>
      ),
    },
    {
      field: content.FIELDS.EXPERIENCE,
      headerName: content.HEADERS.EXPERIENCE,
      sortable: false,
      disableColumnMenu: true,
      width: getColumnWidth(200, 150, 80),
      flex: getColumnFlex(0.5),
      renderCell: (params) => (
        <div className="staff-aug-table-cell">{params.value}</div>
      ),
    },
    {
      field: content.FIELDS.STATUS,
      headerName: content.HEADERS.STATUS,
      sortable: false,
      disableColumnMenu: true,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
      renderCell: (params) => {
        const getStatusColour =
          statusOptions.find((option) => option.name === params.value)
            ?.statusColor || '#7A757F';
        return (
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <div className="staff-augmentation-status-dropdown">
              <SearchDropdown
                options={statusOptions}
                value={params.value === 'N/A' ? 'Select' : params.value}
                searchBox={false}
                onChange={(event) => {
                  if (!hasAccess('update')) return;
                  handleReqStatusChange(params.id, event.target.value);
                }}
                customCss={customStatusStyles(getStatusColour)}
                id="staff-augmentation-status-dropdown"
                disabled={!hasAccess('update')}
              />
            </div>
          </div>
        );
      },
    },

    {
      field: content.FIELDS.RESUME_STATUS,
      headerName: content.HEADERS.RESUME_GENERATION_STATUS,
      sortable: false,
      disableColumnMenu: true,
      width: getColumnWidth(200, 200, 120),
      flex: getColumnFlex(0.7),
      renderCell: (params) => {
        let className = '';
        switch (params.value) {
          case 'Completed':
            className = 'resume-status-completed';
            break;
          case 'In progress':
            className = 'resume-status-in-progress';
            break;
          case 'Failed':
            className = 'resume-status-failed';
            break;
          default:
            className = '';
        }
        return <span className={className}>{params.value}</span>;
      },
    },
    {
      field: content.FIELDS.ACTIONS,
      headerName: content.HEADERS.ACTIONS,
      type: 'number',
      width: getColumnWidth(120, 120, 60),
      flex: getColumnFlex(0.5),
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      renderCell: (params) => (
        <div className="staff-aug-action-icons-container" style={{ position: 'relative' }}>
          <button
            disabled={!hasAccess('delete')}
            id="request-resource-delete-button"
            aria-label="delete"
            className="staff-aug-action-btn"
            onClick={() => handleDeleteClick(params.row)}
          >
            <img
              src={!hasAccess('delete') ? DisabledDeleteIcon : DeleteIcon}
              alt="Delete"
              className="staff-aug-action-icon"
            />
          </button>
          <button
            id="request-resource-menu-button"
            aria-label="menu"
            className="staff-aug-action-btn"
            ref={el => { menuButtonRefs.current[params.row.id] = el; }}
            onClick={(e) => handleMenuClick(e, params.row.id)}
          >
            <img
              src={menuIcon}
              alt="Menu"
              className="staff-aug-action-icon"
            />
          </button>
          {menuAnchorEls[params.row.id] &&
            ReactDOM.createPortal(
              <div
                className="staff-aug-popup-card"
                ref={el => { popupRefs.current[params.row.id] = el; }}
                style={{
                  position: 'absolute',
                  top: popupPosition[params.row.id]?.top ?? 0,
                  left: popupPosition[params.row.id]?.left ?? 0,

                }}
              >
                {hasAccess('update') ? (
                  <div
                    className="staff-aug-popup-card-option"
                    onClick={() => handleEditResource(params.row)}
                  >
                    Edit
                  </div>
                ) : (
                  <div className="staff-aug-popup-card-option staff-aug-popup-card-option-disabled">
                    Edit
                  </div>
                )}
                <div
                  className={`staff-aug-popup-card-option${
                    !params.row.isResumeUploaded || !canViewResume
                      ? ' staff-aug-popup-card-option-disabled'
                      : ''
                  }`}
                  onClick={
                    params.row.isResumeUploaded && canViewResume
                      ? () => handleViewResume(params.row)
                      : undefined
                  }
                >
                  View Resume
                </div>
                <div
                  className={`staff-aug-popup-card-option${!canGenerateResume(params.row) ? ' staff-aug-popup-card-option-disabled' : ''}`}
                  onClick={canGenerateResume(params.row) ? () => handleGenerateResume(params.row) : undefined}
                >
                  Generate Resume
                </div>
                <div
                  className={`staff-aug-popup-card-option${!canUploadResume ? ' staff-aug-popup-card-option-disabled' : ''}`}
                  onClick={canUploadResume ? () => handleUploadResume(params.row) : undefined}
                >
                  Upload Resume
                </div>
              </div>,
              document.body
            )}
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const handleMapEmployeeModel = () => {
    setMapEmployeeModel(false);
    setEditEmployeeData(null);
  };

  const handleNavigateToPage = () => {
    navigate('/staff-augmentation/requirement');
  };

  const handleDeleteRequriment = async () => {
    try {
      const response = await UseAxios(
        deleteStaffRequirement(staffResourceRequestId)
      );
      if (response.status === 200) {
        getResourceRequirementData();
        getStatusData();
        snackbarOpen(
          STAFF_AUGMENTATION.DELETE_RESOURCE_SUCCESS_MESSAGE,
          STAFF_AUGMENTATION.DELETE_SUCCESS_SEVERITY
        );
      }
      if (response.data.status === 500) {
        throw new Error(STAFF_AUGMENTATION.DELETE_ERROR_MESSAGE);
      }
    } catch (error) {
      snackbarOpen(
        STAFF_AUGMENTATION.DELETE_ERROR_MESSAGE,
        STAFF_AUGMENTATION.DELETE_ERROR_SEVERITY
      );
    } finally {
      setIsDeleteDialogOpen(false);
    }
  };

  const pageContent = selectEmployee?.isInteviewRequired
    ? content.ENABLE_DISABLE_DIALOG.DISABLE
    : content.ENABLE_DISABLE_DIALOG.ENABLE;

  const sortFilterColumns = desktopColumns
    .filter(
      (column) =>
        column.field !== content.FIELDS.ACTIONS &&
        column.field !== content.FIELDS.INTERVIEW
    )
    .map((column) => column.field);


  const cardData = [
    { title: "Skills required", icon: SkillIcon, value: skillsRequired },
    { title: "No of positions", icon: PositionIcon, value: noOfPositions },
    { title: "Fulfilled positions", icon: FulfilledPositionIcon, value: noOfFulfilledPositions },
    { title: "On-boarded positions", icon: OnboardPositionIcon, value: noOfOnboardPositions },
    { title: "Interview required", icon: InterviewRequiredIcon, value: interviewRequired },
    { title: "Emp experience (Years)", icon: EmpExperienceIcon, value: empExperience }
  ];

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDownloadExcel = async () => {
    try {
      if (rows.length === 0) {
        snackbarOpen('No data to download', 'warning');
        return;
      }
      await getResourceRequirementReportsExcel(id);
    } catch (error) {
      snackbarOpen(OOPS_TRY_AGAIN, 'warning');
    } finally {
      handleCloseMenu();
    }
  };

  const handleDownloadPdf = async () => {
    try {
      if (rows.length === 0) {
        snackbarOpen('No data to download', 'warning');
        return;
      }
      await getResourceRequirementReportsPdf(id);
    } catch (error) {
      snackbarOpen(OOPS_TRY_AGAIN, 'warning');
    } finally {
      handleCloseMenu();
    }
  };

  const handleMenuClick = (event, rowId) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPopupPosition((prev) => ({
      ...prev,
      [rowId]: {
        top: rect.bottom + window.scrollY + 4,
        left: rect.left + window.scrollX - 130,
      },
    }));
    setMenuAnchorEls((prev) => ({ ...prev, [rowId]: true }));
    setSelectedMenuRow(rowId);
  };

  const handleMenuClose = (rowId) => {
    setMenuAnchorEls((prev) => ({ ...prev, [rowId]: null }));
    setSelectedMenuRow(null);
  };

  const fetchAndSetResumeUrl = async (
    employeeId,
    staffingId,
    resumeTrackerId,
    retries = 2
  ) => {
    try {
      const resumeResponse = await UseAxios(
        getViewFileData(employeeId, staffingId, false, true, resumeTrackerId)
      );
      setResumeFileUrl(resumeResponse?.data?.resumeDetails?.fileUrl || '');
      setViewFileLoader(false);
      setResumeUpdateProgress(false);
    } catch (error) {
      if (retries > 0) {
        console.warn('Retrying fetchAndSetResumeUrl...', retries);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await fetchAndSetResumeUrl(
          employeeId,
          staffingId,
          resumeTrackerId,
          retries - 1
        );
      } else {
        console.error('Error in Fetch And Set ResumeUrl:', error);
        setResumeFileUrl('');
      }
    }
  };

  const handleViewResume = async (row) => {
    try {
      await fetchAndSetResumeUrl(row.employeeId, id, row.resumeTrackerId);
      setSelectedResumeRow(row);
      setViewResumeDialogOpen(true);
    } catch (error) {
      console.error('Error fetching resume:', error);
      snackbarOpen('Failed to fetch resume. Please try again.', 'error');
    } finally {
      handleMenuClose(row.id);
    }
  };

  const fetchEditResumeContent = async (
    employeeId,
    staffingId,
    resumeTrackerId
  ) => {
    try {
      const response = await UseAxios(
        getViewFileData(employeeId, staffingId, false, false, resumeTrackerId)
      ); //isResumeView= false
      const encryptedResumeData =
        response?.data?.resumeDetails?.encryptedResume || {};
      const { encryptedHtml, iv, key, authTag } = encryptedResumeData;
      const decrypted = await decryptHtml(encryptedHtml, iv, key, authTag);
      setHtmlResumeContent(decrypted);
    } catch (error) {
      console.error('Error in Fetch And Set ResumeUrl:', error);
      setHtmlResumeContent('');
    }
  };

  const handleEditResumeClick = async (row) => {
    try {
      await fetchEditResumeContent(row.employeeId, id, row?.resumeTrackerId);
      setGenerateResumeDialogOpen(true);
    } catch (error) {
      console.error('Error fetching resume:', error);
      snackbarOpen(
        'Failed to get edit resume content. Please try again.',
        'error'
      );
    }
  };

  const handleGenerateResume = async (row) => {
    setSelectedResumeRow(row);
    handleMenuClose(row.id);
    setResumeWatermarkModalOpen(true);
  };

  const onSubmitResumeGenerate = async (row) => {
    setResumeWatermarkModalOpen(false);
    const payload = {
      staffingId: id,
      employeeId: row.employeeId,
      lastUpdatedBy: userProfile.user_name,
      watermark: isCheckboxChecked,
      others: row?.others,
      resumeTrackerId: row?.resumeTrackerId,
    };
    const response = await UseAxios(generateResume(payload));
    if (response?.status === 200) {
      snackbarOpen(
        content.RESUME_GENERATION_INITIATED,
        STAFF_AUGMENTATION.SUCCESS_SEVERITY
      );
      setRows((prevList) =>
        prevList.map((item) =>
          item.id === row.id
            ? { ...item, resumeGeneratedStatus: 'In progress' }
            : item
        )
      );
    }
  };

  const handleEditResource = (row) => {
    setEditEmployeeData(row);
    setMapEmployeeModel(true);
    handleMenuClose(row.id);
  };

  const handleUploadResume = (row) => {
    setSelectedUploadRow(row);
    handleMenuClose(row.id);
    setUploadResumeModalOpen(true);
  };

  const handleViewSuggestions = async () => {
    await getResourceViewSuggestionData();
    setIsSuggestedDialogOpen(true);
  };

  const handleCloseSuggestedDialog = () => {
    setIsSuggestedDialogOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      Object.entries(popupRefs.current).forEach(([rowId, ref]) => {
        if (
          ref &&
          !ref.contains(event.target) &&
          menuAnchorEls[rowId] &&
          (!menuButtonRefs.current[rowId] ||
            !menuButtonRefs.current[rowId].contains(event.target))
        ) {
          handleMenuClose(rowId);
        }
      });
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuAnchorEls]);

  return (
    <div className="staff-aug-status-outer-layer">
      <div className="staff-aug-status-master">
        <div className="staff-aug-status-title">
          <button className="back-arrow" onClick={handleNavigateToPage}>
            <img src={BackIcon} alt="Back" />
          </button>
          {`${clientName}${content.HEADER}`}
        </div>
        <div className="staff-aug-cards">
          {cardData?.map((data) => (
            <StaffCard key={data.title} data={data} />
          ))}
        </div>
        <div className="staff-aug-status-create-button">
          <div className="staff-aug-status-create-button-left">
            <MultiSelectSearchDropdown
              dropdownCss="filter-dropdwon-employee"
              options={employeeNameOptions}
              placeholder="Employee Name"
              id="request-resource-employee-name"
              showFilterIcon={false}
              value={selectedEmployeeName}
              onChange={(event) => setSelectedEmployeeName(event.target.value)}
              disabled={employeeNameOptions.length === 0}
            />
            <ButtonComponent
              label={STAFF_AUGMENTATION.VIEW_SUGGESTIONS}
              variant="text"
              btnCss="download-resource-req-btn"
              onClick={handleViewSuggestions}
            />
          </div>
          <div className="staff-aug-status-create-button-right">
            <div>
              <ButtonComponent
                label={STAFF_AUGMENTATION.DOWNLOAD}
                variant="text"
                onClick={handleDownloadClick}
                endIcon={<img src={ArrowDropDown} alt="Dropdown Arrow" />}
                btnCss="download-resource-req-btn"
              />
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={handleDownloadPdf}
                  className="download-resource-req-dropdown"
                  onMouseEnter={() => setIsPdfHovered(true)}
                  onMouseLeave={() => setIsPdfHovered(false)}
                >
                  <img
                    src={isPdfHovered ? pdfhoverIcon : pdfIcon}
                    style={{ marginRight: 8 }}
                    alt="PDF Icon"
                  />{' '}
                  Download as PDF
                </MenuItem>
                <MenuItem
                  onClick={handleDownloadExcel}
                  className="download-resource-req-dropdown"
                  onMouseEnter={() => setIsExcelHovered(true)}
                  onMouseLeave={() => setIsExcelHovered(false)}
                >
                  <img
                    src={isExcelHovered ? excelhoverIcon : excelIcon}
                    style={{ marginRight: 8 }}
                    alt="Excel Icon"
                  />{' '}
                  Download as Excel
                </MenuItem>
              </Menu>
            </div>
            <div>
              <ButtonComponent
                disabled={!hasAccess('create')}
                id="add-staff-aug-status-btn"
                label={content.MAP_EMPLOYEE}
                variant="contained"
                startIcon={<AddIcon />}
                btnCss={
                  !hasAccess('create')
                    ? 'add-staff-aug-status-btn-disabled'
                    : 'add-staff-aug-status-btn'
                }
                onClick={() => setMapEmployeeModel(true)}
              />
            </div>
          </div>
        </div>
        <div className="staff-status-data-grid-container">
          <DataGridComponent
            dataRows={rows?.length ? rows : []}
            dataColumns={desktopColumns?.length ? desktopColumns : []}
            sortFilterColumns={
              sortFilterColumns?.length ? sortFilterColumns : []
            }
            pageSize={10}
            isFilteredRows={rows?.length ? rows : []}
          />
        </div>
      </div>
      <MapEmployee
        modalOpen={mapEmployeeModel}
        handleClose={handleMapEmployeeModel}
        statusOptions={statusOptions}
        staffId={id}
        getResourceRequirementData={getResourceRequirementData}
        editEmployeeData={editEmployeeData}
      />
      <EnableDisableCategoryDialog
        isDialogOpen={isDialogOpen}
        selectedRow={selectEmployee}
        content={pageContent}
        handleCloseAction={handleDialogClose}
        handleEnableDisableAction={handleSubmit}
        onPageChange={(params) => setCurrentPage(params.page)} // Track current page
        page={currentPage} // Set current page
      />
      <DeleteResourceRequirementDialog
        isOpen={isDeleteDialogOpen}
        handleCloseAction={handleDialogClose}
        handleDeleteAction={handleDeleteRequriment}
        setIsDialogOpen={setIsDeleteDialogOpen}
      />
      <ViewResumeDialog
        modalOpen={viewResumeDialogOpen}
        handleClose={() => {
          setViewResumeDialogOpen(false);
          setResumeViewerOpen(false);
          setResumeFileUrl('');
          setHtmlResumeContent('');
        }}
        resumeFileUrl={resumeFileUrl}
        htmlResumeContent={htmlResumeContent}
        selectedResumeRow={selectedResumeRow}
        generateResumeDialogOpen={generateResumeDialogOpen}
        setGenerateResumeDialogOpen={setGenerateResumeDialogOpen}
        handleEditResumeClick={handleEditResumeClick}
        setHtmlResumeContent={setHtmlResumeContent}
        fetchAndSetResumeUrl={fetchAndSetResumeUrl}
        lastUpdatedBy={userProfile?.user_name}
        setViewFileLoader={setViewFileLoader}
        viewFileLoader={viewFileLoader}
        setRows={setRows}
        resumeUpdateProgress={resumeUpdateProgress}
        setResumeUpdateProgress={setResumeUpdateProgress}
      />
      <ViewSuggestionDialog
        isOpen={isSuggestedDialogOpen}
        handleClose={handleCloseSuggestedDialog}
        lastUpdatedBy={userProfile.user_name}
        staffingId={id}
        getResourceRequirementData={getResourceRequirementData}
        suggestions={suggestions}
        noSuggestions={noSuggestions}
      />
      <UploadResumeDialog
        openAddModal={uploadResumeModalOpen}
        handleClose={() => {
          setUploadResumeModalOpen(false);
        }}
        selectedUploadRow={selectedUploadRow}
        lastUpdatedBy={userProfile?.user_name}
        setRows={setRows}
      />
      <ResumeWatermarkDialog
        openModal={resumeWatermarkModalOpen}
        handleClose={() => {
          setResumeWatermarkModalOpen(false);
        }}
        selectedResumeRow={selectedResumeRow}
        onSubmitResumeGenerate={onSubmitResumeGenerate}
        isCheckboxChecked={isCheckboxChecked}
        setIsCheckboxChecked={setIsCheckboxChecked}
        onCheckboxChange={(checked) => setIsCheckboxChecked(checked)}
        generateResume={true}
      />
    </div>
  );
};
export default StaffAugRequestRequirement;
